import { ComponentChildren } from 'preact';
import type { DiagramLink, States, LinkRendererContext } from './Diagram.types';
import { DiagramLinkElement } from './DiagramLinkElement';
import { layerStyles } from './themes/DiagramStyles.css';

type Props<K2, K1> = {
  links: DiagramLink<K2, K1>[];
  states: States<K1, K2>;
  previousStates: States<K1, K2>;
  linkRenderer: (context: LinkRendererContext<K2, K1>) => ComponentChildren;
  width: number;
  height: number;
  supportsSelection: boolean;
};

export function DiagramLinkLayer<K2, K1>({
  links,
  states,
  previousStates,
  linkRenderer,
  width,
  height,
  supportsSelection
}: Props<K2, K1>) {
  return (
    <svg class={layerStyles} width={width} height={height}>
      {links.map((link) => {
        const state = {
          selected: states.selectedLinkIds.includes(link.id),
          focused: states.focusedId === link.id,
          hovered: states.hoveredId === link.id,
          zoom: states.zoom
        };
        const previousState = {
          selected: previousStates.selectedLinkIds.includes(link.id),
          focused: previousStates.focusedId === link.id,
          hovered: previousStates.hoveredId === link.id,
          zoom: previousStates.zoom
        };
        return (
          <DiagramLinkElement
            id={link.id}
            label={link.label}
            state={state}
            previousState={previousState}
            isDimmed={states.highlightedIds.length !== 0 && !states.highlightedIds.includes(link.id)}
            activeId={states.activeId}
            accessibleLabel={link.accessibleLabel}
            data={link}
            linkRenderer={linkRenderer}
            supportsSelection={supportsSelection}
          />
        );
      })}
    </svg>
  );
}
